export default __webpack_public_path__ + "static/media/ImagebackgroundAbout.e38085d1.png";